module.exports = __webpack_public_path__ + "static/media/dispatch-1.b502956b.jpg";